function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{filter:url(#Adobe_OpacityMaskFilter);}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st2{mask:url(#mask-2_1_);enable-background:new    ;}\n\t.st3{fill:#222426;}\n\t.st4{filter:url(#Adobe_OpacityMaskFilter_1_);}\n\t.st5{mask:url(#mask-2_2_);}\n\t.st6{fill:#206EE8;}\n");

var _ref3 = /*#__PURE__*/React.createElement("title", null, "Group");

var _ref4 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  id: "texture-lockup---1-copy-6",
  transform: "translate(-357.000000, -406.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(330.000000, 404.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Clip-2"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "Adobe_OpacityMaskFilter",
  filterUnits: "userSpaceOnUse",
  x: 27.5,
  y: 23.4,
  width: 268.3,
  height: 47
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
}))), /*#__PURE__*/React.createElement("mask", {
  maskUnits: "userSpaceOnUse",
  x: 27.5,
  y: 23.4,
  width: 268.3,
  height: 47,
  id: "mask-2_1_"
}, /*#__PURE__*/React.createElement("g", {
  className: "st0"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1_1_",
  className: "st1",
  points: "0,0 691.2,0 691.2,87.6 0,87.6  "
}))), /*#__PURE__*/React.createElement("g", {
  className: "st2"
}, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M27.5,70.4V34.6h3.8l0.4,4.1c0.8-1.2,1.9-2.3,3.4-3.2c1.5-1,3.4-1.5,5.7-1.5c2.5,0,4.6,0.6,6.5,1.7 c1.8,1.1,3.3,2.7,4.3,4.7c1,2,1.5,4.2,1.5,6.7s-0.5,4.7-1.5,6.7c-1,2-2.5,3.5-4.3,4.6c-1.8,1.1-4,1.7-6.5,1.7 c-2,0-3.8-0.4-5.4-1.2c-1.6-0.8-2.8-2-3.6-3.5v15.2H27.5z M40.2,56.3c1.7,0,3.1-0.4,4.4-1.2c1.3-0.8,2.3-1.9,3-3.3 c0.7-1.4,1.1-3,1.1-4.9c0-1.9-0.4-3.5-1.1-4.9c-0.7-1.4-1.7-2.5-3-3.3c-1.3-0.8-2.7-1.2-4.4-1.2c-1.7,0-3.1,0.4-4.4,1.2 c-1.3,0.8-2.3,1.9-3,3.3c-0.7,1.4-1.1,3-1.1,4.9c0,1.9,0.4,3.5,1.1,4.9c0.7,1.4,1.7,2.5,3,3.3C37.1,56,38.6,56.3,40.2,56.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M70.1,60c-2.3,0-4.4-0.5-6.3-1.6c-1.9-1.1-3.3-2.6-4.4-4.5c-1.1-1.9-1.6-4.2-1.6-6.9c0-2.6,0.6-4.9,1.6-6.9 c1.1-1.9,2.6-3.5,4.5-4.5c1.9-1.1,4-1.6,6.3-1.6c2.3,0,4.4,0.5,6.3,1.6c1.9,1.1,3.3,2.6,4.4,4.5c1.1,2,1.6,4.2,1.6,6.9 c0,2.6-0.6,4.9-1.7,6.9c-1.1,2-2.6,3.5-4.5,4.5C74.6,59.5,72.5,60,70.1,60z M70.1,56.4c1.4,0,2.8-0.3,4-1c1.2-0.7,2.2-1.8,3-3.2 c0.8-1.4,1.1-3.1,1.1-5.2c0-2.1-0.4-3.8-1.1-5.2c-0.8-1.4-1.7-2.5-3-3.2c-1.2-0.7-2.5-1-3.9-1c-1.4,0-2.8,0.3-4,1 c-1.2,0.7-2.2,1.8-3,3.2c-0.8,1.4-1.1,3.1-1.1,5.2c0,2.1,0.4,3.8,1.1,5.2c0.8,1.4,1.8,2.5,3,3.2C67.4,56,68.7,56.4,70.1,56.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M92.5,59.4l-7.2-24.8h4.2L94.7,54l5.8-19.5h4.8l5.8,19.5l5.2-19.5h4.2l-7.2,24.8H109l-6.1-20.5l-6.1,20.5 H92.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M135.4,60c-2.4,0-4.5-0.5-6.3-1.6c-1.8-1.1-3.3-2.6-4.3-4.5c-1.1-1.9-1.6-4.2-1.6-6.9 c0-2.6,0.5-4.9,1.6-6.8c1-2,2.5-3.5,4.3-4.6c1.9-1.1,4-1.6,6.4-1.6c2.4,0,4.5,0.5,6.2,1.6c1.8,1.1,3.1,2.5,4,4.3 c0.9,1.8,1.4,3.7,1.4,5.7c0,0.4,0,0.7,0,1.1c0,0.4,0,0.8,0,1.2h-19.8c0.1,1.9,0.5,3.5,1.3,4.7c0.8,1.2,1.8,2.2,3,2.8 c1.2,0.6,2.4,1,3.8,1c1.7,0,3.2-0.4,4.4-1.2c1.2-0.8,2-1.9,2.5-3.2h4.1c-0.7,2.3-1.9,4.2-3.8,5.7C140.7,59.2,138.3,60,135.4,60z  M135.4,37.5c-2,0-3.8,0.6-5.3,1.8c-1.5,1.2-2.4,3-2.7,5.3H143c-0.1-2.2-0.9-4-2.3-5.2C139.3,38.2,137.5,37.5,135.4,37.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M152.7,59.4V34.6h3.8l0.4,4.8c0.8-1.6,1.9-2.9,3.5-3.9c1.6-1,3.5-1.5,5.8-1.5v4.4H165c-1.5,0-2.8,0.3-4,0.8 c-1.2,0.5-2.2,1.4-3,2.6c-0.7,1.2-1.1,2.9-1.1,5.1v12.5H152.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M181,60c-2.4,0-4.5-0.5-6.3-1.6c-1.8-1.1-3.3-2.6-4.3-4.5c-1.1-1.9-1.6-4.2-1.6-6.9c0-2.6,0.5-4.9,1.6-6.8 c1-2,2.5-3.5,4.3-4.6c1.9-1.1,4-1.6,6.4-1.6c2.4,0,4.5,0.5,6.2,1.6c1.8,1.1,3.1,2.5,4,4.3c0.9,1.8,1.4,3.7,1.4,5.7 c0,0.4,0,0.7,0,1.1c0,0.4,0,0.8,0,1.2H173c0.1,1.9,0.5,3.5,1.3,4.7c0.8,1.2,1.8,2.2,3,2.8c1.2,0.6,2.4,1,3.8,1 c1.7,0,3.2-0.4,4.4-1.2c1.2-0.8,2-1.9,2.5-3.2h4.1c-0.7,2.3-1.9,4.2-3.8,5.7C186.4,59.2,184,60,181,60z M181,37.5 c-2,0-3.8,0.6-5.3,1.8c-1.5,1.2-2.4,3-2.7,5.3h15.6c-0.1-2.2-0.9-4-2.3-5.2C184.9,38.2,183.1,37.5,181,37.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M209.6,60c-2.5,0-4.6-0.6-6.5-1.7s-3.3-2.7-4.3-4.7c-1-2-1.5-4.2-1.5-6.7s0.5-4.7,1.6-6.7 c1-2,2.5-3.5,4.3-4.6c1.8-1.1,4-1.7,6.5-1.7c2,0,3.8,0.4,5.4,1.2c1.6,0.8,2.8,2,3.6,3.5V23.4h4.2v36h-3.8l-0.4-4.1 c-0.8,1.2-1.9,2.3-3.4,3.2C213.7,59.5,211.9,60,209.6,60z M210,56.3c1.7,0,3.1-0.4,4.4-1.2c1.3-0.8,2.3-1.9,3-3.3 c0.7-1.4,1.1-3,1.1-4.9c0-1.9-0.4-3.5-1.1-4.9c-0.7-1.4-1.7-2.5-3-3.3c-1.3-0.8-2.8-1.2-4.4-1.2c-1.6,0-3.1,0.4-4.4,1.2 c-1.3,0.8-2.3,1.9-3,3.3c-0.7,1.4-1.1,3-1.1,4.9c0,1.9,0.4,3.5,1.1,4.9c0.7,1.4,1.7,2.5,3,3.3C207,56,208.4,56.3,210,56.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M256.2,60c-2,0-3.8-0.4-5.4-1.2c-1.6-0.8-2.8-2-3.6-3.5l-0.4,4.2H243v-36h4.2v15.3c0.8-1.2,1.9-2.3,3.4-3.2 c1.5-1,3.4-1.5,5.7-1.5c2.5,0,4.6,0.6,6.5,1.7c1.8,1.1,3.3,2.7,4.3,4.7c1,2,1.5,4.2,1.5,6.7s-0.5,4.7-1.5,6.7 c-1,2-2.5,3.5-4.3,4.6C260.9,59.4,258.7,60,256.2,60z M255.8,56.3c1.7,0,3.1-0.4,4.4-1.2c1.3-0.8,2.3-1.9,3-3.3 c0.7-1.4,1.1-3,1.1-4.9c0-1.9-0.4-3.5-1.1-4.9c-0.7-1.4-1.7-2.5-3-3.3c-1.3-0.8-2.7-1.2-4.4-1.2c-1.7,0-3.1,0.4-4.4,1.2 c-1.3,0.8-2.3,1.9-3,3.3c-0.7,1.4-1.1,3-1.1,4.9c0,1.9,0.4,3.5,1.1,4.9c0.7,1.4,1.7,2.5,3,3.3C252.7,56,254.1,56.3,255.8,56.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M275.1,70.4l6.1-13.4h-1.4l-9.9-22.4h4.5l8.2,19.3l8.7-19.3h4.3l-16.2,35.8H275.1z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "Adobe_OpacityMaskFilter_1_",
  filterUnits: "userSpaceOnUse",
  x: 328,
  y: 2.5,
  width: 322,
  height: 77.2
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
}))), /*#__PURE__*/React.createElement("mask", {
  maskUnits: "userSpaceOnUse",
  x: 328,
  y: 2.5,
  width: 322,
  height: 77.2,
  id: "mask-2_2_"
}, /*#__PURE__*/React.createElement("g", {
  className: "st4"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1_2_",
  className: "st1",
  points: "0,0 691.2,0 691.2,87.6 0,87.6  "
}))), /*#__PURE__*/React.createElement("g", {
  id: "sherpa-logo-onwhite",
  className: "st5"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(328.000000, 2.000000)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  className: "st6",
  d: "M308.4,27.9c-7.7,0-13.6-5.9-13.6-13.5c0-7.9,5.9-13.9,13.6-13.9c7.8,0,13.6,6,13.6,13.9 C322,21.9,316,27.9,308.4,27.9z M308.4,7.1c-4.1,0-7.1,3.1-7.1,7.3c0,3.9,3,6.9,7.1,6.9c4.1,0,7.1-3,7.1-6.9 C315.4,10.2,312.5,7.1,308.4,7.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path",
  className: "st3",
  d: "M10.7,50.4c0,2.2,2.7,5.8,8.9,5.8c6.3,0,8.4-2.1,8.4-4.9c0-2.7-1.3-4.3-6.2-5.1L14.7,45 C5.4,43.6,0.1,39.7,0.1,32.1c0-7.5,6.7-14.2,19.1-14.2c13.2,0,19.1,9.4,19.1,14.7H27.6c0-2.7-3.1-5.8-8.4-5.8s-8,2.6-8,5.3 c0,2.1,2.1,3.5,6.2,4.2l7.5,1.1c9.4,1.4,14.2,5.7,14.2,13.8c0,7.5-6.3,13.8-19.6,13.8C2.7,65,0,53.4,0,50.3h10.7V50.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M49,6.3h11.1v17h0.5c0.8-1,1.9-1.9,3-2.7c2.1-1.3,5.1-2.7,9.4-2.7c10.2,0,17.8,7.5,17.8,19.1v27.1H79.8V38 c0-5.8-4-9.8-9.8-9.8s-9.8,4-9.8,9.8v26.2H49.1L49,6.3L49,6.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M144.3,50.8c-1,3.5-6.6,14.2-20.9,14.2c-13.4,0-23.1-9.8-23.1-23.6c0-13.8,9.8-23.6,23.1-23.6 c12.4,0,22.2,9.8,22.2,22.7c0,1.3-0.2,2.4-0.3,3.2l-0.2,1.3h-33.8c1,6.3,5.7,10.7,12,10.7c5.3,0,8.4-3,9.4-4.9L144.3,50.8 L144.3,50.8z M134.5,37.5c-1-5.8-4.8-10.2-11.1-10.2c-6.7,0-10.7,4.5-12,10.2H134.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M155.5,18.8h9.4l0.9,4h0.5c0.5-0.7,1.1-1.3,1.9-1.9c1.3-1,3.3-2.1,6.1-2.1h8.9v10.7h-8 c-5.6,0-8.4,2.9-8.4,8.4v26.2h-11.1L155.5,18.8L155.5,18.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M191.9,18.8h10.2l0.9,4.9h0.5c0.8-1.1,1.9-2.1,3.1-2.9c2.1-1.4,5.3-2.9,9.8-2.9c11.5,0,20.9,9.4,20.9,23.6 s-9.4,23.6-20.9,23.6c-4.7,0-7.9-1.3-9.9-2.7c-1.1-0.8-2.1-1.7-2.9-2.7h-0.5v17.9H192L191.9,18.8L191.9,18.8z M214.7,28.1 c-6.7,0-11.5,4.8-11.5,13.4s4.8,13.4,11.5,13.4s11.5-4.8,11.5-13.4S221.4,28.1,214.7,28.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M275.3,59.7h-0.5c-0.8,1-1.9,1.9-3.1,2.7c-2.1,1.3-5.3,2.7-9.8,2.7c-10.3,0-16.4-6.3-16.4-13.8 c0-8.9,6.2-15.1,18.7-15.1h10.2v-0.9c0-5-3-8.4-8-8.4c-5,0-7.5,3.2-8,5.8h-11.1c1-7.5,7-14.7,19.1-14.7 c11.5,0,19.1,7.7,19.1,17.4v28.9h-9.4L275.3,59.7z M274.4,44.6h-9.4c-5.8,0-8.4,2.2-8.4,5.8c0,3.5,2.6,5.8,7.1,5.8 c6.7,0,10.7-3.9,10.7-10.2V44.6L274.4,44.6z"
}))))));

var SvgPoweredbysherpaOnlight = function SvgPoweredbysherpaOnlight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 623 78",
    style: {
      enableBackground: "new 0 0 623 78"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPoweredbysherpaOnlight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/poweredbysherpa-onlight.7d92deb5.svg";
export { ForwardRef as ReactComponent };